import { enumTipoPessoa } from 'shared/domains/enumtipopessoa.enum';

export class UsuarioAutenticado
{
    public IdentificadorLogAcesso: number =  null;
    public IdentificadorUsuario: number=null;
    public IdentificadorConta: number=null;
    public NumeroConta: string=null;
    public NumeroAgencia: string = null;
    public ISPBBanco: string = null;
    public CodigoBanco: string = null;
    public CPFCNPJ: string = null;
    public TipoPessoa: enumTipoPessoa = null;
    public NomeCliente: string = null;
    public Token: string = null;
    public Login: string = null;
    public NomeUsuario: string = null;
    public PrimeiroAcesso: boolean = false;
    public ChaveMFALiberada: boolean=false;
    public IdentificadorPerfil: number = null;
    public PixValidado: boolean=false;
    public IBConfirmacao: boolean=false;
    public Funcionalidades: number[] = [];
}